 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		98: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~pages-admin-teams~pages-class-details-logged-in~pages-class-details-logged-out~pages-class-d~056cf466","1":"vendors~pages-class-details-logged-in~pages-class-details-logged-out~pages-classes~pages-classes-cla~8ed26321","2":"dllVendors","3":"tinymce","4":"vendors~pages-adminMarketingBanner~pages-home~pages-site~pages-visa~pages-visa-footer","5":"d3","6":"vendors~pages-class-details-logged-in~pages-class-details-logged-out~pages-site-gallery~pages-workshops-show","7":"vendors~pages-adminMarketingBanner~pages-home~pages-site","8":"pages-classes~pages-classes-class-collections~pages-site","9":"pages-embed-video~pages-site-join~pages-workshops-show","10":"pages-classes-class-collections~pages-customLists-lists","11":"pages-embed-video~pages-site-join","12":"pages-site-settings-payment~pages-teams-checkout","13":"pages-adminMarketingBanner","14":"pages-class-details-logged-in","15":"pages-class-details-logged-out","16":"pages-class-details-reviews","17":"pages-classes","18":"pages-customLists","19":"pages-error","20":"pages-home","21":"pages-marketingPages","22":"pages-notifications","23":"pages-projects","24":"pages-redeem","25":"pages-search","26":"pages-site","27":"pages-teach","28":"pages-teacherStats","29":"pages-teaching","30":"pages-userProfile","31":"pages-visa","32":"pages-yourClasses","33":"vendors~pages-class-details-logged-out","34":"vendors~pages-classes","35":"vendors~pages-search","36":"vendors~pages-visa","37":"pages-admin-adjust-team-seats","38":"pages-admin-batch-delete-users","39":"pages-admin-coupons","40":"pages-admin-monthly-revenue","41":"pages-admin-teacher-payout","42":"pages-admin-teams","43":"pages-admin-trust-and-safety","44":"pages-admin-users-show","45":"pages-adminMarketingBanner-edit","46":"pages-checkout-item","47":"pages-class-details-logged-in-class-admin","48":"pages-classes-class-collections","49":"pages-classes-create","50":"pages-classes-video-lessons-table","51":"pages-common-footer","52":"pages-customLists-form","53":"pages-customLists-lists","54":"pages-customLists-show","55":"pages-embed-project","56":"pages-embed-video","57":"pages-giftCards-form","58":"pages-membership-cancel","59":"pages-membership-cancel-step-two","60":"pages-membership-paypal-cancel","61":"pages-membership-paypal-success","62":"pages-membership-perks","63":"pages-membership-react-checkout","64":"pages-membership-rejoin","65":"pages-membership-welcome","66":"pages-projects-edit","67":"pages-reviews-create","68":"pages-site-gallery","69":"pages-site-join","70":"pages-site-login","71":"pages-site-premium-landing","72":"pages-site-scholarships","73":"pages-site-settings-account","74":"pages-site-settings-language","75":"pages-site-settings-notifications","76":"pages-site-settings-payment","77":"pages-site-settings-react-account","78":"pages-site-settings-referrals","79":"pages-site-settings-teacher-referrals","80":"pages-site-settings-team-administration","81":"pages-teach-form","82":"pages-teams-activate","83":"pages-teams-checkout","84":"pages-teams-new","85":"pages-teams-signup","86":"pages-userProfile-discussionShow","87":"pages-userProfile-discussions","88":"pages-visa-check","89":"pages-visa-footer","90":"pages-visa-header","91":"pages-workshops-form","92":"pages-workshops-show","93":"pages-workshops-test-index","94":"vendors~pages-membership-react-checkout","95":"vendors~pages-projects-edit","96":"vendors~pages-site-settings-referrals","97":"vendors~pages-visa-header"}[chunkId]||chunkId) + ".build." + {"0":"f25d32566346c4b2d9e7","1":"884b97e5e128a2c22478","2":"bff0a01e38fe34c55b78","3":"1ccf7af7c8c741514162","4":"abad02a51c0a312be9fe","5":"5e93656ddb97fef6d943","6":"10637f5b3240583b9a5e","7":"3ca20c763a1c1162ccbc","8":"d1a15f631f61187a313b","9":"00820c4e829272faeee3","10":"77d361874fae94fea96e","11":"c45772bea98b305ced9d","12":"eaac84cd7c8203180feb","13":"665a237e3c75393a8b85","14":"d721e615700ca13b8ea5","15":"d11b56a5d1a2ac19cfa8","16":"5095bdba655016493b67","17":"a0fd578085e74ef17fb6","18":"2a3c8af6a1b786796e7e","19":"a699d74be3affc3fcdc6","20":"536f77eaced5fb045aec","21":"eb50db86cceb7b99be37","22":"442e1788918eacb9e920","23":"b5ecf9cdc6200b4a2ad9","24":"d53223286d7b4e45b064","25":"01ab1d6c4cc37caf7b18","26":"87c9dab56dec7c55f8ce","27":"fed601c838092c05b78a","28":"f65e3b393c71148193ba","29":"b4991f3cf63f19695dc0","30":"809e2eda95726470e760","31":"13147dbd647e220fb320","32":"723a8492137feeef0bc5","33":"726146c0c7af1dfe2e5d","34":"3b3dee5bf628d9bc32ec","35":"c0a1ca9db7f7b336ffbf","36":"24640852d315e631cb19","37":"f4bed3ffcca2d4a7630e","38":"727114ba49b7ebc1f856","39":"0d31b49fe76f2d7e3206","40":"0b11d5425aafdf38df1d","41":"618cbaad3e3edfe88582","42":"5b6f80678ec429701e05","43":"7d8e0868d64bfadc02e8","44":"0fd1c6166b6d1ab5aa36","45":"d9e53643f2776b53fdea","46":"1abb9c6890054f0f8519","47":"5cdeccd821a1c3bcd651","48":"f7f439c1bb094b61d47e","49":"ab0755eb137ee45e8678","50":"7cf347353d5875ea02ab","51":"dd427fdcb5ab8f8f54e0","52":"f25937925be41d7f0ca0","53":"a9a289901840965b9edd","54":"fa4084bc939c61592cf6","55":"decd6ded5a0adf491e28","56":"25abc1b0fe7973889628","57":"6236c7c2e4c48e7555f9","58":"369c1cb133ef6839ae9f","59":"cfce0159afc52368613e","60":"7366af02ed5b7d9cffa7","61":"9850d4b94b8eda988a4a","62":"185450fbf32ca434aab4","63":"f56f5b42ae382558414f","64":"a320058b166760497b07","65":"cec373d0846824fd5574","66":"c9fcc426611695751200","67":"3f9e42d0afcc166f1b58","68":"9447d7d4e0c894b622bc","69":"17a4f3a35b0b38ee63f3","70":"5944b6c84c36f8c4d4e5","71":"bbe69f63b1cc2d9bcb29","72":"467535c7b388293d3ab4","73":"acc5c0634feba4669bb3","74":"4f88ea2f452d4fca8700","75":"99dbbd6447713cc77147","76":"12e2e2d61475c0533f29","77":"5438b0d2fd86dc4a8c4e","78":"7318a19965b9a06c2261","79":"ee336f38eff3050c17f2","80":"364fc1b737f4aadc1816","81":"f3f8bbd1d25535cefab8","82":"5d18b8a731a85e0ce57f","83":"d3777c413db0fef0b2da","84":"1ad76b80169cde13a738","85":"ecbc5bd152297ce9c977","86":"90c2e396727a88b770f0","87":"3ea873382b6b13c59240","88":"3a1bf8c55b0be492fe90","89":"40be636578d599c113e5","90":"ecc9ec74db1b8ab242e7","91":"8532c0affe4ff47ed72e","92":"374d4a071a0d905dfc40","93":"4544e18e73e2ca0918dc","94":"6ef3b78f06cc67504338","95":"5bb5da0cdf358a7585d1","96":"a40d221fd6320f7c15f7","97":"dbb29e6e78cad2f41f7c","99":"a26e59456a5b6317f8ef","100":"84c0d368f3dcbbe94bae","101":"f8f7f125d8ba5ea94da8","102":"a617c09b5bbfabf05f96","103":"42031aafdd0881ecedf8","104":"60fcce6d4b22602d5fc4","105":"3a8fdc25388ecbb52350","106":"6948268075ce6d9ea794","107":"e98031918c5177223943"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.skillshare.com/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 769);
